import axios from "axios";
import { baseURL } from "../config/api";

export const getYears = () => {
    return getFetch(`vehicleYears`)
}

export const getBrandsByYear = () => {
    return getFetch(`makes`)
}

export const getModelsByBrand = (makeId: number) => {
    return getFetch(`models/GetModelsByMakeId/${makeId}`)
}


const getFetch = (url: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}